module.exports = __webpack_public_path__ + "static/media/A2_22.06838ab2.png";